import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/network-admin",
    name: ROUTE_NAME.NETWORK_ADMIN,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.NETWORK_MANAGEMENT },
    children: [
      {
        path: "",
        name: ROUTE_NAME.NETWORK_MANAGEMENT,
        component: () => import("./views/NetworkManagementView.vue"),
      },
      {
        path: "create-organization",
        name: ROUTE_NAME.NETWORK_CREATE_ORGANIZATION,
        component: () => import("./views/CreateOrganizationView.vue"),
      },
      {
        path: "organizations/:id",
        name: ROUTE_NAME.NETWORK_ORGANIZATION_DETAIL,
        component: () => import("./views/NetworkOrganizationDetailView.vue"),
        props: true,
      },
    ],
  },
];
